import { render, staticRenderFns } from "./IpGuidePopup.vue?vue&type=template&id=49099df3&"
import script from "./IpGuidePopup.vue?vue&type=script&lang=ts&"
export * from "./IpGuidePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports